import angular from 'angular';
import app from '../../app';
import { ignoredSegments, textBySegment, getSegmentRequiredRules } from './constants';

app.service('navigationService', [
  'addFormService',
  'userService',
  function (addFormService, userService) {
    this.links = [];

    this.textBySegment = textBySegment;

    this.getNavigationItemsForTelemetry = () => {
      return this.links.map(link => ({
        id: link.id,
        isValid: this.isVerified(link),
      }));
    };

    this.isVerified = link => {
      const adTypeRule = () => {
        return !!addFormService.ad.category; // Нету категории - значит не заполнены все поля из "Тип объявления"
      };

      const authLastStepRule = () => {
        const form = addFormService.form['$ctrl.form'];

        if (!form) {
          return true;
        }

        const { passwordErrorMessage } = form.registrationPassword || {};

        return form.$valid && !passwordErrorMessage;
      };

      // Прошел ли КП премодерацию
      const isKpValid = () => {
        const field = addFormService.form.cottageVillageName;

        return field ? field.$valid : true;
      };

      const requiredRules = getSegmentRequiredRules(isKpValid, adTypeRule, authLastStepRule)[link.id] || [];

      if (requiredRules.length === 0) {
        return true;
      }

      for (const rule of requiredRules) {
        if (angular.isFunction(rule)) {
          if (!rule()) {
            return false;
          }
        } else if (angular.isString(rule)) {
          if (addFormService.form[rule] && addFormService.form[rule].$invalid) {
            return false;
          }
        }
      }

      return true;
    };

    this.watchSegments = segments => {
      // Если одновременно отображаются сегменты contact-info и phone-verify, отображаются две ссылки Контакты подряд
      if (segments.includes('contact-info') && segments.includes('phone-verify')) {
        // Убираем phone-verify, так как номер уже подтверждён
        ignoredSegments.push('phone-verify');
      }

      const links = segments
        .filter(segment => !ignoredSegments.includes(segment))
        .map(segment => {
          const textKey = segment === 'address' && this.category === 'newBuildingFlatSale' ? 'address-jk' : segment;

          return {
            id: segment,
            text: textBySegment[textKey],
          };
        });
      if (this.category && !userService.isAuthenticated) {
        links.push({
          id: 'ad-placing-terms',
          text: textBySegment['ad-placing-terms'],
          disabled: true,
        });
      }

      this.links = links;
    };
  },
]);
